export class OrderTagItemModel {
    constructor() {
        this.tagId = 0;
        this.printedCount = 0;
        this.preProcessCount = 0;
        this.pressureCount = 0;
    }
}
